import { apiGetHelper, apiPutHelper, apiPostHelper } from "helper/api";
import { DOMAIN } from "constants/base";
import axios from 'axios'
import { checkDeviceType, getCookie, isEmpty, isMobileSite } from "utils";
export const getStatus = (data = "") => {
  const URL = `${DOMAIN}/people/status?` + data;
  const response = apiGetHelper(URL);
  return response;
  // return { status: "Unconfirmed" };
};

export const signIn = (data = {}) => {
  const URL = `${DOMAIN}/v2/signin`;

  const payload = {
    type: "POST",
    body: JSON.stringify(data),
  };

  const requestHeaders = {
    'X-CT-SOURCETYPE': 'web',
    service: window.location.pathname,
  }

  const response = apiPostHelper(URL, payload, requestHeaders);
  return response;
};

export const activateUser = (data, id) => {
  const URL = `${DOMAIN}/activate/${id}`;
  const payload = {
    type: "POST",
    body: JSON.stringify(data),
  };
  const response = apiPostHelper(URL, payload);
  return response;
  // return { status: "success" };
};

export const updateUser = (data) => {
  const URL = `${DOMAIN}/workplus/user/update`;
  const payload = {
    type: "PUT",
    body: data,
  };
  const response = apiPutHelper(URL, payload);
  return response;
};

export const registerUser = (data) => {
  const URL = `${DOMAIN}/expressway-register`;
  const payload = {
    type: "POST",
    body: data,
  };
  const response = apiPostHelper(URL, payload, {
    Accept:
      "text/json, text/javascript, text/html, application/xml, text/xml, */*",
    "Content-Type": "application/x-www-form-urlencoded, charset=UTF-8",
  });
  return response;
};

export const accountProfile = (data) => {
  const URL = `${DOMAIN}/partial/account/profile?` + data;
  const response = apiGetHelper(URL, { type: "GET" }, { Accept: "text/json" });
  return response;
};

export const personalization = (localStorageDeviceId) => {
  try {
    const URL = `${DOMAIN}/personalization` 
    const header = {
      caller: DOMAIN,
    ...(localStorageDeviceId && {dvid:localStorageDeviceId}),
    ...(window && !isEmpty(window?.parent?.androidData?.['device_id']) && {dvid:window?.parent?.androidData?.['device_id']}), 
    ...(window &&  !isEmpty(window?.parent?.iosData?.['device_id']) && {dvid:window?.parent?.iosData?.['device_id']}),
    'app-agent':!isEmpty(window?.parent?.iosData) ? "iPhoneApp":!isEmpty(window?.parent?.androidData) ? "AndroidApp" :"PWA"
    }
    const response = personalizationAxios(URL, {}, header)
    return response
  } catch (e) {
    console.error(e)
  }
};

export const personalizationAxios = async (
  URL,
  contentType,
  requestHeaders
) => {
  try {
    let contentTypeText = "text/plain;charset=UTF-8";
    if (contentType) {
      contentTypeText = contentType;
    }
let deviceType = checkDeviceType()
if ( deviceType === 'iPhoneApp') { 
  deviceType = 'iOS'
} else if ( deviceType === 'AndroidApp') {
  deviceType = 'Android'
} else {
  deviceType = 'PWA'
}
    let headers = {
      Accept: "application/json",
      r_lang: getCookie("lp") || "",
      "Content-Type": contentTypeText,
      "Preferred-Language": getCookie("lp") || "",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
      X_CT_SOURCETYPE: "MOBILE",
      "app-agent":isMobileSite() ? deviceType : 'DESKTOP',
    };
    if (!isEmpty(requestHeaders)) {
      headers = {
        ...headers,
        ...requestHeaders,
      };
    }
    const responseData = await axios.get(URL, {
      headers,
    });
    return responseData;
  } catch (e) {
    //setSentryError(e)
    return e;
  }
};